import { html } from 'lit';
import { actionLink } from '../components/actionLink.js';
import { combineHeadingTitle, highlightedHeading } from '../components/highlightedHeading.js';
import { type LandingContent } from '../../shared/content/landingContent.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';
import heroVideoUrl from '../../video/hero bg video.mp4';

export const heroSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    id="top"
    class=${editorNodeClass(editor, 'section.hero', 'vp-hero')}
    style=${editorNodeStyle(editor, 'section.hero')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.hero', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.hero', event)}
  >
    <video
      class=${editorNodeClass(editor, 'hero.video', 'vp-hero-video')}
      style=${editorNodeStyle(editor, 'hero.video')}
      autoplay
      muted
      loop
      playsinline
      preload="metadata"
      src=${content.hero.videoUrl || heroVideoUrl}
      aria-hidden="true"
      tabindex="-1"
      @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'hero.video', event)}
      @click=${(event: MouseEvent) => editorNodeClick(editor, 'hero.video', event)}
    ></video>
    <div
      class=${editorNodeClass(editor, 'hero.copy', 'vp-hero-copy')}
      style=${editorNodeStyle(editor, 'hero.copy')}
      @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'hero.copy', event)}
      @click=${(event: MouseEvent) => editorNodeClick(editor, 'hero.copy', event)}
    >
      ${highlightedHeading({
        title: combineHeadingTitle(content.hero.title, content.hero.highlight),
        highlight: content.hero.highlight,
        className: 'vp-hero-title',
        editor,
        titleElementId: 'hero.title',
        highlightElementId: 'hero.highlight',
      })}
      <p
        class=${editorNodeClass(editor, 'hero.intro', 'vp-hero-intro')}
        style=${editorNodeStyle(editor, 'hero.intro')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'hero.intro', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'hero.intro', event)}
      >
        ${content.hero.intro}
      </p>

      <ul class="vp-hero-bullets">
        ${content.hero.bullets.map(
          (bullet, index) => html`
            <li>
              <span class="vp-hero-bullet-icon icon-[material-symbols--check-circle]"></span>
              <span
                class=${editorNodeClass(editor, `hero.bullet.${index}`, 'vp-hero-bullet-text')}
                style=${editorNodeStyle(editor, `hero.bullet.${index}`)}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `hero.bullet.${index}`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `hero.bullet.${index}`, event)}
                >${bullet}</span
              >
            </li>
          `,
        )}
      </ul>

      <div
        class=${editorNodeClass(editor, 'hero.actions', 'vp-hero-actions')}
        style=${editorNodeStyle(editor, 'hero.actions')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'hero.actions', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'hero.actions', event)}
      >
        ${actionLink({ action: content.hero.primaryAction, editor, elementId: 'hero.primaryAction.label' })}
        ${actionLink({
          action: content.hero.secondaryAction,
          variant: 'secondary',
          editor,
          elementId: 'hero.secondaryAction.label',
        })}
      </div>
    </div>
  </section>
`;
